import { getTaskStatisticsCallTimeSeconds, getTaskStatisticsDisplayCallCount } from '@frontend/api-client';
import type { TaskStatistics } from '@frontend/api-types';
import { formatDuration, formatDurationLong, pluralize } from '@frontend/duck-tape';
import { Text, XStack, YStack } from '@frontend/web-react';
import { SectionCard } from '@frontend/web/components/DomainSpecific/DraftTasks';

const ActivityTextPart = ({ children, isEmphasized }: { children: string; isEmphasized?: boolean }) => (
  <Text className={isEmphasized ? 'font-bold' : undefined} color={isEmphasized ? 'primary' : 'secondary'} type="p-lg">
    {children}
  </Text>
);

export const TaskStatisticsCard = ({ taskStatistics }: { taskStatistics: TaskStatistics }) => {
  const callTimeSeconds = getTaskStatisticsCallTimeSeconds(taskStatistics);
  const displayCallCount = getTaskStatisticsDisplayCallCount(taskStatistics);
  const savedTime = formatDurationLong(taskStatistics.totalTaskTimeSeconds);
  const callTime = formatDuration(callTimeSeconds);
  const holdTime = formatDuration(taskStatistics.timeOnHoldSeconds);
  const showPhoneActivity = displayCallCount > 0;
  const showHoldTime = showPhoneActivity && taskStatistics.timeOnHoldSeconds > 0;

  return (
    <SectionCard icon="IconActivity" title="Activity">
      <YStack>
        <XStack flexWrap="wrap" gapX="xs">
          <ActivityTextPart>Duckbill saved you</ActivityTextPart>
          <ActivityTextPart isEmphasized>{savedTime}</ActivityTextPart>
          {showPhoneActivity ? (
            <>
              <ActivityTextPart>on this task:</ActivityTextPart>
              <ActivityTextPart isEmphasized>{`${displayCallCount}`}</ActivityTextPart>
              <ActivityTextPart>{`${pluralize('call', displayCallCount)},`}</ActivityTextPart>
              <ActivityTextPart isEmphasized>{callTime}</ActivityTextPart>
              <ActivityTextPart>{showHoldTime ? 'on the phone, and' : 'on the phone.'}</ActivityTextPart>
              {showHoldTime ? (
                <>
                  <ActivityTextPart isEmphasized>{holdTime}</ActivityTextPart>
                  <ActivityTextPart>on hold.</ActivityTextPart>
                </>
              ) : null}
            </>
          ) : (
            <ActivityTextPart>on this task.</ActivityTextPart>
          )}
        </XStack>
      </YStack>
    </SectionCard>
  );
};
